/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import SpinnerButton from "../../Button";
import { useAuth } from "../../../context/AuthContext";
import { handleErrors } from "../../../services/handleErrors";
import { PasswordInput } from "../../PasswordInput";

const PasswordForm = ({ isRemplacing }) => {
  const { updateUserData, refreshToken } = useAuth();
  const [validPassword, setvalidPassword] = useState(false);

  const updateProfile = async (values, actions) => {
    try {
      await updateUserData(values);
    } catch (err) {
      handleErrors(err, toast.error, refreshToken);
    } finally {
      actions.setSubmitting(false);
    }
  };
  return (
    <Formik
      initialValues={{
        oldPassword: "",
        newPassword: "",
        confirm: "",
      }}
      onSubmit={updateProfile}
      validationSchema={Yup.object().shape({
        oldPassword: Yup.string().required("Este campo es requerido."),
        newPassword: Yup.string()
          .required("Este campo es requerido.")
          .test("valid-password", "Password invalida", () => validPassword),
        confirm: Yup.string()
          .required("Este campo es requerido.")
          .oneOf([Yup.ref("newPassword"), null], "La nueva contraseña debe coincidir."),
      })}
    >
      {(props) => {
        const { values, touched, errors, isSubmitting, handleChange, handleBlur, handleSubmit } = props;
        return (
          <form className="card dmx-card-mt flex-grow-1 mr-4" onSubmit={handleSubmit}>
            <div className="card-header">
              <h5>ACTUALIZAR CONTRASEÑA</h5>
              <div className="card-options">
                <a className="card-options-collapse" href="javascript" data-toggle="card-collapse" aria-label="Toggle Card">
                  <i className="fe fe-chevron-up" />
                </a>
                <a className="card-options-remove" href="javascript" data-toggle="card-remove" aria-label="Remove Card">
                  <i className="fe fe-x" />
                </a>
              </div>
            </div>
            <div className="card-body" style={{ width: "90%", margin: "0 auto" }}>
              <div className="row d-flex flex-column">
                <div className="md-3 flex-column">
                  <div className="form-group">
                    <p className="form-label mb-1">Contraseña Actual</p>
                    <PasswordInput
                      className={errors.oldPassword && touched.oldPassword ? "error-field" : ""}
                      placeholder="Contraseña actual"
                      name="oldPassword"
                      disabled={isSubmitting || isRemplacing}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.oldPassword}
                    />
                    {errors.oldPassword && touched.oldPassword && <div className="input-feedback">{errors.oldPassword}</div>}
                  </div>
                </div>
                <div className="md-3 flex-column">
                  <div className="form-group">
                    <p className="form-label mb-1">Nueva Contraseña</p>
                    <PasswordInput
                      className={errors.newPassword && touched.newPassword ? "error-field" : ""}
                      placeholder="Nueva contraseña"
                      name="newPassword"
                      maxLength="50"
                      onValidChange={setvalidPassword}
                      disabled={isSubmitting || isRemplacing}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.newPassword}
                    />
                    {errors.newPassword && touched.newPassword && <div className="input-feedback">{errors.newPassword}</div>}
                  </div>
                </div>
                <div className="md-3 flex-column">
                  <div className="form-group">
                    <p className="form-label mb-1">Confirmación</p>
                    <PasswordInput
                      className={errors.confirm && touched.confirm ? "error-field" : ""}
                      placeholder="Confirme la contraseña"
                      name="confirm"
                      disabled={isSubmitting || isRemplacing}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.confirm}
                    />
                    {errors.confirm && touched.confirm && <div className="input-feedback">{errors.confirm}</div>}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer text-right">
              <SpinnerButton className="btn btn-primary " isLoading={isSubmitting} type="submit" disabled={isRemplacing}>
                Actualizar contraseña
              </SpinnerButton>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default PasswordForm;
